export default "__VITE_ASSET__CfRHP5TE__"